<template>
  <div style="margin:20px">
    <FiPageRail title="Tyler Route Processor" />

    <div class="d-flex flex-column align-items-center" style="font-size: 22px; font-weight: bold; position: relative; margin: 30px; gap: 18px;">
      <div v-if="legacy_location_options.length > 0" class="d-flex align-items-center">
        Route Mappings:&nbsp;
        <b-form-select
          v-model="selected_legacy_location"
          :options="legacy_location_options"
          style="font-size: 20px; font-weight: bold; width:350px"
          @input="on_legacy_select"
        />
      </div>
      <div v-if="sync_keys_location_options.length > 0" class="d-flex align-items-center">
        MDM Sync Keys:&nbsp;
        <b-form-select
          v-model="selected_sync_keys_location"
          :options="sync_keys_location_options"
          style="font-size: 20px; font-weight: bold; width:350px"
          @input="on_sync_keys_select"
        />
      </div>
      <div v-if="legacy_location_options.length === 0 && sync_keys_location_options.length === 0" style="font-style: italic;">
        No Tyler route locations configured.
      </div>
      <div class="d-flex align-items-center" style="gap: 12px;">
        <b-button v-on:click.prevent="process_routes(true)" :disabled="loading || !selected_location">Run In QA</b-button>
        <b-button v-on:click.prevent="process_routes(false)" :disabled="loading || !selected_location">Run In Prod</b-button>
      </div>
    </div>

    <div v-if="items.length > 0" >
        <div v-for="item in items" style="border: 1px solid black;margin: 6px; padding: 10px; text-align: left">
          {{item}}
        </div>
    </div>
  </div>
</template>

<script>

import {get_tyler_route_options, process_tyler_routes} from '../networking/tbn_apis'
import {mapState} from "vuex";
import moment from 'moment'

const empty_option = { value: '', text: 'Select a location...' }

export default {
  name: 'tyler_route_processor',
  components: {
  },

  data() {
    return {
      remarks_filter: '',
      items: [],
      summary: [],
      loading: false,
      selected_legacy_location: '',
      selected_sync_keys_location: '',
      legacy_location_options: [],
      sync_keys_location_options: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pages: [],
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
        toolbarPlacement: 'top',
      },

    }
  },

  async created() {
    this.fields_all = this.fields
    this.check_features()
  },
  methods: {
    async check_features() {
      this.legacy_location_options = []
      this.sync_keys_location_options = []
      this.selected_legacy_location = ''
      this.selected_sync_keys_location = ''
      try {
        const {value: {data = {}}} = await get_tyler_route_options(this.user.tenant)
        const legacy = Array.isArray(data.legacy) ? data.legacy : (Array.isArray(data) ? data : [])
        const sync_keys = Array.isArray(data.sync_keys) ? data.sync_keys : []
        this.legacy_location_options = [empty_option, ...legacy]
        this.sync_keys_location_options = [empty_option, ...sync_keys]
      } catch(e) {
        this.$emit('showAlert', 'error loading data, try logging in again or contact support if needed', 'danger', 5000)
      }
    },
    on_legacy_select(value) {
      if (value) {
        this.selected_sync_keys_location = ''
      }
    },
    on_sync_keys_select(value) {
      if (value) {
        this.selected_legacy_location = ''
      }
    },
    async process_routes(inQA) {
      if (!this.selected_location || !this.selected_mode) {
        return
      }
      this.loading = true
      this.items = []
      const location_label = this.selected_location
      try {
        this.$emit('showAlert', 'processing import for ' + location_label + ', this may timeout, but results will be emailed to you once completed', 'info', 60000)
        const {value: { data = [] } } = await process_tyler_routes(this.user.tenant, this.selected_location, inQA, this.selected_mode)
        this.items = data
        this.$emit('showAlert', 'finished processing import for ' + location_label, 'success', 5000)
      } catch(e) {
        this.$emit('showAlert', 'error processing import for ' + location_label, 'danger', 5000)
      }
      this.loading = false
    },
    get_row_color(item, type) {
      if (item != null)
        return item.hosStatusType
    },
    filter_by_status(status) {
        this.selected_status = status
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    }

  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    selected_location() {
      return this.selected_legacy_location || this.selected_sync_keys_location
    },
    selected_mode() {
      if (this.selected_legacy_location) {
        return 'legacy'
      }
      if (this.selected_sync_keys_location) {
        return 'sync_keys'
      }
      return ''
    },
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
  }
}
</script>

<style>

</style>
